<template>
  <div>
    <div class="mt-5 wr-text__small wr-text--dark opacity-50 text-center">
      &copy; PenguinOS by
      <a href="https://loopedreality.com" target="_blank" class="wr-text--dark"
        >Looped Reality</a
      >
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped></style>
